export default "/storefront/client/images/subscriptions-icon.png";